import BaseSettings from "../../../core/src/ui/BaseSettings";
import Button from "../../../core/src/views/components/Button";
import showAutoplayPage from "./AutoplayPage";
import SwitchButton from "../../../core/src/views/components/SwitchButton";
import SoundController from "../../../core/src/utils/SoundController";
import PointerEvents from "../../../core/src/const/PointerEvents";
import BetModel from "../../../core/src/model/BetModel";
import {
    MoneyField,
} from "../../../core/src/views/MoneyField";
import SoundVars from "../../../core/src/const/SoundVars";
import { Commands } from "../../../core/src/commands/CommandEnum";
import CommandManager from "../../../core/src/commands/CommandManager";
import SceneView from "../../../core/src/views/SceneView";

const WINS_MAP = {
    pt_sym_ruby_1: { s: "M3", n: 3 }, //0.8,
    pt_sym_ruby_2: { s: "M3", n: 4 }, //2,
    pt_sym_ruby_3: { s: "M3", n: 5 }, //4,
    pt_sym_yellow_1: { s: "M1", n: 3 }, //1.5,
    pt_sym_yellow_2: { s: "M1", n: 4 }, //3.5,
    pt_sym_yellow_3: { s: "M1", n: 5 }, //7.5,
    pt_sym_star_1: { s: "M2", n: 3 }, //1,
    pt_sym_star_2: { s: "M2", n: 4 }, //2.5,
    pt_sym_star_3: { s: "M2", n: 5 }, //5,
    pt_sym_superboost_1: { s: "WW", n: 3 }, //3,
    pt_sym_superboost_2: { s: "WW", n: 4 }, //10,
    pt_sym_superboost_3: { s: "WW", n: 5 }, //50,
    pt_sym_k_1: { s: "F7", n: 3 }, //0.2,
    pt_sym_k_2: { s: "F7", n: 4 }, //1,
    pt_sym_k_3: { s: "F7", n: 5 }, //1.5,
    pt_sym_triangle_1: { s: "F5", n: 3 }, //0.5,
    pt_sym_triangle_2: { s: "F5", n: 4 }, //1.2,
    pt_sym_triangle_3: { s: "F5", n: 5 }, //2.5,
    pt_sym_a_1: { s: "F6", n: 3 }, //0.2,
    pt_sym_a_2: { s: "F6", n: 4 }, //1,
    pt_sym_a_3: { s: "F6", n: 5 }, //1.5,
    pt_sym_square_1: { s: "M4", n: 3 }, //0.8,
    pt_sym_square_2: { s: "M4", n: 4 }, //1.5,
    pt_sym_square_3: { s: "M4", n: 5 }, //3.5,
    pt_sym_10_1: { s: "F0", n: 3 }, //0.1,
    pt_sym_10_2: { s: "F0", n: 4 }, //0.5,
    pt_sym_10_3: { s: "F0", n: 5 }, //1,
    pt_sym_j_1: { s: "F9", n: 3 }, //0.1,
    pt_sym_j_2: { s: "F9", n: 4 }, //0.5,
    pt_sym_j_3: { s: "F9", n: 5 }, //1,
    pt_sym_q_1: { s: "F8", n: 3 }, //0.2,
    pt_sym_q_2: { s: "F8", n: 4 }, //1,
    pt_sym_q_3: { s: "F8", n: 5 }, //1.5,
};
import GameModel from "../../../core/src/model/GameModel";
import { UIStates } from "../../../core/src/ui/UIStates";
import Locale from "../../../core/src/utils/Locale";
import { ConfigurationTypes } from '../../../core/src/const/ConfigurationTypes';
import ConfigManager from '../../../core/src/managers/ConfigManager';
import IVendorClientConfigRequestData from '../../../server/requests/contracts/IVendorClientConfigRequestData';

export default class Settings extends BaseSettings {
    public paytablePageScenes: string[];
    public payTablePage: number = 1;
    public currentSettingsPage: string;
    public buttonsNames: { [key: string]: string } = {
        close: "close",
        settings: "settings",
        autoplay: "autospin",
        betOptions: "bet",
        rightArrow: "next",
        leftArrow: "previous",
        soundOff: "soundOff",
        soundOn: "soundOn",
        sound: "sound",
        home: "home",
    };

    protected pages: Map<string, () => void> = new Map();
    protected leftArrow: Button;
    protected rightArrow: Button;

    constructor() {
        super();
        this.pages.set("autoplay", () => this.showAutoPlay());
        this.pages.set("bet", () => this.showBetOptions());
        this.pages.set("settings", () => this.showPayTable());
        this.pages.set("paytable", () => this.showPayTable());

        this.navigationActions.set(this.buttonsNames.rightArrow, () =>
            this.arrowNavigate("next")
        );
        this.navigationActions.set(this.buttonsNames.leftArrow, () =>
            this.arrowNavigate("previous")
        );
        this.navigationActions.set(this.buttonsNames.close, (e) => {
            e.stopPropagation();
            CommandManager.execute(Commands.CLOSE_SETTINGS)
        });
        this.navigationActions.set(this.buttonsNames.settings, () =>
            this.showPayTable()
        );
        this.navigationActions.set(this.buttonsNames.autoplay, () =>
            this.showAutoPlay()
        );
        this.navigationActions.set(this.buttonsNames.betOptions, () =>
            this.showBetOptions()
        );
        this.navigationActions.set(this.buttonsNames.soundOff, () =>
            this.toggleSound()
        );
        this.navigationActions.set(this.buttonsNames.soundOn, () =>
            this.toggleSound()
        );
        this.navigationActions.set(this.buttonsNames.sound, () =>
            this.showAudioSettings()
        );
        this.navigationActions.set(this.buttonsNames.home, () =>
            CommandManager.execute(Commands.GO_HOME)
        );

        // remove when settings are done
        this.defaultPage = "settings";

    }

  protected setBehaviours() {
    this.setBehaviour(UIStates.IDLE, {
        uiToEnable:this.buttons
    });
    this.setBehaviour(UIStates.SPIN, {
        uiToDisable:this.buttons
    });
    this.setBehaviour(UIStates.DEFAULT, {
        uiToDisable:this.buttons
    });
}

    public hide() {
        this.currentSettingsPage = "";
        SoundController.playSound(SoundVars.BUTTON_CLICK);
        super.hide();
    }

    public show(page?: string) {
        super.show();
        this.rightArrow = this.interfaceScene.buttons.get(
            this.buttonsNames.rightArrow
        );
        this.leftArrow = this.interfaceScene.buttons.get(
            this.buttonsNames.leftArrow
        );
        this.buttons = [];
        this.interfaceScene.buttons.forEach((btn)=>{
            if(btn != this.rightArrow && btn != this.leftArrow && btn != this.interfaceScene.buttons.get(this.buttonsNames.close)) {
                if(ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.autoplayDisable &&  btn === this.interfaceScene.buttons.get(this.buttonsNames.autoplay) ) {
                    btn.setEnabled(false);
                } else {
                    this.buttons.push(btn);
                }
            }
        });
        this.setBehaviours();
        if(!GameModel.isMobile() &&GameModel.urlParams.hidehome	) {
            this.interfaceScene.buttons.get("home").visible = false;
        }
        if (!this.pages.has(page)) {
            page = this.defaultPage;
        }
        this.pages.get(page)();
        this.update();

    }

    public update() {
        if(this.currentSettingsPage != "paytable") {

            if (this.leftArrow) {
                this.leftArrow.visible = false;
            }
            if (this.rightArrow) {
                this.rightArrow.visible = false;
            }
        }
    }

    protected showAudioSettings() {
        SoundController.playSound(SoundVars.BUTTON_CLICK);
        if (this.currentSettingsPage == "sound") {
            return;
        }
        this.currentSettingsPage = "sound";
        this.scene = this.contentLayer.setScene("sound");
        let musicToggle = this.scene.buttons.get("sound") as SwitchButton;
        let soundToggle = this.scene.buttons.get("music") as SwitchButton;
        soundToggle.switch(SoundController.isEffectsEnabled);
        musicToggle.switch(SoundController.isMusicEnabled);

        soundToggle.on(PointerEvents.DOWN, () => {
            soundToggle.toggle();
            CommandManager.execute(Commands.TOGGLE_SOUND_FX,soundToggle.isSelected());
            // SoundController.toggleEffects(soundToggle.isSelected());
            // SoundController.masterVolume = soundToggle.isSelected() ? 1 : 0;

            // this.saveSettings();
        });

        musicToggle.on(PointerEvents.DOWN, () => {
            musicToggle.toggle();
            CommandManager.execute(Commands.TOGGLE_MUSIC,musicToggle.isSelected());
            // SoundController.toggleMusic(musicToggle.isSelected());
            // SoundController.masterVolume = musicToggle.isSelected() ? 1 : 0;
            // this.saveSettings();
        });
        this.update();
    }

    private saveSettings() {
        CommandManager.execute(Commands.SAVE_SETTINGS);
    }

    public showAutoPlay() {
        this.currentSettingsPage = "autoplay";
        this.update();
        SoundController.playSound(SoundVars.BUTTON_CLICK);
        showAutoplayPage();
    }

    protected showPayTable() {
        SoundController.playSound(SoundVars.BUTTON_CLICK);
        const scenes: { [key: string]: string } = {
            gamerules: "gamerules",
            paytable: "paytable",
            featurerules: "featurerules",
        };
        this.update();
        this.payTablePage = 1;
        this.currentSettingsPage = scenes.paytable;
        const featureRulesSceneCount = this.contentLayer.getScenesTypeCount(
            scenes.featurerules
        );
        const gameRulesSceneCount = this.contentLayer.getScenesTypeCount(
            scenes.gamerules
        );
        const paytableScenesCount = this.contentLayer.getScenesTypeCount(
            scenes.paytable
        );
        this.paytablePageScenes = [];
        this.createPayTablePagesArray(scenes.featurerules, featureRulesSceneCount);
        this.createPayTablePagesArray(scenes.gamerules, gameRulesSceneCount);
        this.createPayTablePagesArray(scenes.paytable, paytableScenesCount);
        this.scene = this.contentLayer.setScene(
            this.paytablePageScenes[this.payTablePage - 1]
        );
        this.leftArrow.visible = false;
        this.rightArrow.visible = true;

        this.fillTexts();
        this.calculateWins();
    }

    protected createPayTablePagesArray(sceneName: string, pagesCount: number) {
        for (let i = 0; i < pagesCount; i++) {
            this.paytablePageScenes.push(sceneName + "~" + (i + 1));
        }
    }

    protected switchPayTables(direction: string, pagesCount: number) {
        if (direction === "previous" && this.payTablePage > 1) {
            this.payTablePage--;
        }
        if (direction === "next" && this.payTablePage < pagesCount) {
            this.payTablePage++;
        }
        this.leftArrow.visible = !(this.payTablePage === 1);
        this.rightArrow.visible = !(this.payTablePage === pagesCount);
        this.scene = this.contentLayer.setScene(
            this.paytablePageScenes[this.payTablePage - 1]
        );

        this.fillTexts();

        if (this.scene.buttons && this.scene.buttons.has("history")) {
            this.interractionManager.assign(
                Commands.REQUEST_HISTORY,
                this.scene.buttons.get("history")
            );
        }

        this.calculateWins();
    }

    protected fillTexts() {
        // Game version
        if (
            this.scene.sceneTextFields &&
            this.scene.sceneTextFields.has("gameVersion")
        ) {
            this.scene.sceneTextFields.get("gameVersion").text =
                GameModel.gameConfig.version;
        }

        // Feature rules
        if (
            this.scene.sceneTextFields &&
            this.scene.sceneTextFields.has("sb_feature_rules_1")
        ) {
            let body = "";
            body += "● " + Locale.getString("sb_feature_rules_1") + "\n\n";
            body += "● " + Locale.getString("sb_feature_rules_2") + "\n\n";
            body += "● " + Locale.getString("sb_feature_rules_3") + "\n\n";
            body += "● " + Locale.getString("sb_feature_rules_4");

            this.scene.sceneTextFields.get("sb_feature_rules_1").text = body;
        }

        // Game Rules
        if (
            this.scene.sceneTextFields &&
            this.scene.sceneTextFields.has("sb_game_rules_1")
        ) {
            let body = "";
            body += "● " + Locale.getString("sb_game_rules_1") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_2") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_3") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_4") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_5") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_6");

            this.scene.sceneTextFields.get("sb_game_rules_1").text = body;
        }

        // Game Rules 2
        if (
            this.scene.sceneTextFields &&
            this.scene.sceneTextFields.has("sb_game_rules_7")
        ) {
            let body = "";
            body += "● " + Locale.getString("sb_game_rules_7") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_8") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_9") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_10") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_11") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_12") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_13") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_14") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_15") + "\n\n";
            body += "● " + Locale.getString("sb_game_rules_16");

            this.scene.sceneTextFields.get("sb_game_rules_7").text = body;
        }
    }

    protected calculateWins() {
        if (this.scene.sceneMoneyFields) {
            let serverPaytable = GameModel.serverGameConfig.paytable;

            Object.keys(WINS_MAP).forEach((key) => {
                if (this.scene.sceneMoneyFields.has(key)) {

                    let value = serverPaytable.find(
                        (item) => item.symbol == WINS_MAP[key].s && item.n == WINS_MAP[key].n
                    );

                    this.scene.sceneMoneyFields.get(key).value =
                        value ? BetModel.totalBet * (value.pay / 10) : 0;
                }
            });
        }
    }

    protected showBetOptions() {
        SoundController.playSound(SoundVars.BUTTON_CLICK);
        if (this.currentSettingsPage == "bet") {
            return;
        }
        this.update();
        this.currentSettingsPage = "bet";
        this.scene = this.contentLayer.setScene("bet");


        let j = 0;
        while (this.scene.buttons.has("betAmount~" + (j + 1))) {
            const value = BetModel.creditValues[j];
            let btn = this.scene.buttons.get(
                "betAmount~" + (j + 1)
            ) as SwitchButton;
            console.log("Bet model, coin size index: ", BetModel.coinSizeIndex)
            console.log("Bet model, coin size: ", BetModel.coinSize)
            btn.switch(BetModel.coinSizeIndex == j);
            let betField = this.scene.sceneMoneyFields.get(
                "betAmount~" + (j + 1)
            ) as MoneyField;
            if (!value) {
                btn.visible = false;
                betField.visible = false;
            } else {
                betField.value = value as number;
                this.assignInterraction(
                    [Commands.SET_BET, Commands.SAVE_SETTINGS],
                    btn,
                    SoundVars.BUTTON_CLICK,
                    j
                );
            }
            j++;
        }
    }

    protected toggleSound() {
        //
    }

    protected arrowNavigate(direction: "previous" | "next" = "next") {
        SoundController.playSound(SoundVars.BUTTON_CLICK);
        switch (this.currentSettingsPage) {
            case "paytable":
                this.switchPayTables(direction, this.paytablePageScenes.length);
                break;
            default:
                break;
        }
    }
}
